<template>
  <div
    class="minheight100"
    style="padding-bottom: 130px"
    :class="{ 'bg-grey': dataDetail && dataDetail.activityStatus > 1 }"
  >
    <template v-if="dataDetail">
      <div class="nocon" v-if="dataDetail.activityStatus === 3">
        <img src="./images/close_status.png" />
        <p>活动已关闭</p>
      </div>
      <div class="imgmax" style="text-align: center" v-else>
        <!-- activityRuleDesc -->
        <div class="explain font14" @click="explainShow = true">活动规则</div>
        <img :src="dataDetail.activityCover" />
      </div>
    </template>
    <div class="fixed-bottom" v-if="dataDetail && dataDetail.activityStatus !== 3">
      <div class="btn-common" @click="generatePoster">点击生成海报</div>
      <div class="txt-center color-green" style="padding: 15px 0 10px; font-weight: bold" @click="progressClick">
        查看进度
      </div>
    </div>
    <div class="dialog-mask" v-if="dialogShow">
      <div class="my-swiper" v-if="qrImgpath">
        <swiper :options="swiperOption" ref="mySwiper" class="swiper">
          <swiper-slide v-for="(item, index) in dataShareDetail.canvasObj" :key="index" class="swiper_item">
            <div :id="'capture' + index" style="height: 100%" v-if="item.picUrl && qrImgpath">
              <img
                v-if="item.isGenerate === true"
                style="position: absolute; z-index: 100; top: 0; left: 0; opacity: 0"
                class="cover"
                crossorigin="anonymous"
                :src="item.canvasUrl"
                alt=""
              />

              <img :src="item.picUrl" @load="onImageLoad(index)" crossorigin="anonymous" />
              <div class="qrcode" v-if="qrImgpath">
                <img :src="qrImgpath" />
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="longpress">长按并保存图片，分享至朋友圈</div>
        <div class="dialog-close bottom" style="bottom: -80px; opacity: 0.8" @click="dialogShow = false">×</div>
      </div>
    </div>
    <div class="dialog-mask" v-if="explainShow" @click.stop="explainShow = false">
      <div class="explain-con" @click.stop="">
        <div class="title">活动规则</div>
        <div class="container">
          <div class="myrule">
            <p>参与活动前，请您审慎阅读活动规则。</p>
            <h3>一、活动对象：</h3>
            <p>活动1:【友邻少年3月免费送好礼】活动限满足如下条件用户参与</p>
            <p>
              【过往友邻会员】在友邻少年购买金额累计超899元，购买物品包括但不限于畅听卡、外刊、友邻课程等。
              <br />
              【友邻少年会员】包括无限卡、畅听卡会员期内全部用户。
            </p>
            <p>活动2：【免费领友邻独家大咖英文课】活动不限参与人，所有人均可参与</p>
            <h3>二、活动时间</h3>
            <p>2023年3月1日-3月31日</p>
            <h3>三、活动内容</h3>
            <p>
              1、分享朋友圈，保留2小时，截图上传指定入口，通过审核后可获得实物或虚拟礼品任选其一，礼品于审核通过后15个工作日内发放；（具体奖品以上传页面呈现为准）；
            </p>
            <p>
              2、您的朋友通过您分享的海报，扫码注册友邻少年（需为首次注册），30天内购买畅听卡/无限卡会员，您可再获得一份虚拟/实物奖品，实物礼品将于您兑换成功后15个工作日内发出，虚拟奖品将于您兑换成功后7个工作日内发放；
            </p>
            <p>*因部分活动涉及活动参与资格核查环节，请正确填写您的友邻少年ID</p>
            <p>
              *部分活动限友邻过往会员和当前会员期内学员参与，分享奖单个友邻少年ID每个月限制领取1次；如预留友邻少年ID经过后台检测不满足活动对象要求，则不予发放奖励；相同友邻少年ID单月内只发送1次奖品；该活动与积分活动不可叠加享受。
            </p>
            <h3>四、奖励说明</h3>
            <p>1、分享奖发放时间：实物奖品会在您通过审核后的15个工作日内寄出；虚拟奖品会在您通过审核后7日内发放；</p>
            <p>
              2、邀请奖会在好友成为会员满30天后次月首周统一发放，如：您的好友1月10日成为畅听卡会员，到2月9日满30天，3月首周会联系您选择奖品进行发放。
            </p>
            <h3>五、活动参与流程及标准</h3>
            <p>1、参与流程</p>
            <p>
              1）活动时间内，生成海报，写一小段走心文案并分享至朋友圈，不设分组或私密，并在朋友圈停留至少【2】小时以上
            </p>
            <p>2）2）上传截图，选择奖品，填写收奖信息，审核通过后15个工作日内为您发放奖品；</p>
            <p>3）若您想看截图示例，可进入上传入口查看；</p>
            <p>4）若您想查看截图的审核进度，可点击老师发给您的链接进行查看，或添加活动客服进行查询。</p>
            <p>2、截图审核标准</p>
            <p>- 需分享本活动特定海报</p>
            <p>- 微信名称和头像显示完整</p>
            <p>- 海报在朋友圈保留2小时，不可分组或私密</p>
            <p>- 朋友圈保留完整截图</p>
            <p>- 请务必在每周活动期内审核通过，否则无法领取奖励</p>

            <h3>六、常见问题</h3>
            <p>1、奖品什么时候寄出？</p>
            <p>用户兑换后7-15个工作日寄出。</p>

            <p>2、审核失败后怎么办？</p>
            <p>（1）截图在朋友圈保留2小时，且全员可见</p>
            <p>（2）手机系统语言设置为“中文简体”</p>
            <p>（3）把手机的文字设置为“系统默认文字”</p>
            <p>然后在活动截止时间之前，重新截图并完成上传，审核通过后可获得奖品</p>

            <h3>七、其他说明</h3>
            <p>1、本活动所有数据以友邻少年的海报邀请系统数据为准，邀请好友购会员须通过生成海报进行。</p>
            <p>
              2、请确保您生成专属海报、分享海报、上传截图以及邀请好友均符合活动要求，不符合活动规则的情形，将无法帮您获得奖励。
            </p>
            <p>
              3、本平台依法运营此次活动，如因不可抗力、相关政策等原因导致本次活动调整、暂停举办或无法进行的，本平台有权随时修改、暂停、取消或终止本活动，并无需为此承担任何法律责任。
            </p>
            <p>
              4、任何人不得以本次活动进行违法行为（如滥发短信、微信等骚扰行为），也不得以任何不正当手段或舞弊方式参与本活动（虚假用户，同一用户通过不同账号互相邀请）。
            </p>
            <p>
              5、对于本平台用户，一经发现前述情形，本平台有权取消此用户参与本次活动的资格、收回所获奖品。如其行为构成犯罪，本平台有权移交相应司法机关处理。如因其行为给平台造成损失，同时应当承担赔偿责任。
            </p>
            <p>
              6、在法律允许范围内，本平台有权对本活动规则进行变动或调整。相关变动或调整将公布在本页面上，并于公布时即时生效，用户继续参与该活动则视为对前述变动或者调整后的活动规则予以同意。
            </p>
          </div>
        </div>
        <div class="know">
          <div class="btn-common" @click="explainShow = false">我知道了</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import html2canvas from 'html2canvas'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { activityService } from '@/api'
import QRCode from 'qrcode'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Dialog } from 'vant'
import { appUser } from '@/utils'
import { saTrack } from '@/utils/common/shence'

const action = 'activityIndex'

export default {
  name: '',
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide,
    'van-dialog': Dialog.Component
  },
  data() {
    return {
      title: '',
      activityId: '',
      shareUserId: appUser.userId,
      dialogShow: false,
      explainShow: false,
      shareLoading: false,
      dataDetail: null,
      dataShareDetail: null,
      qrImgpath: '',
      canvasUrl: '',
      swiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        loop: false,
        autoplay: false, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false
        },

        on: {
          slideChangeTransitionEnd: res => {
            //监听滑动
          }
        }
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'fraction'
        // },
      }
    }
  },
  mixins: [Body],
  created() {
    console.log('进来活动created了')
    //https://new-wx.ylyk.com/test/ylyk/payment.html#/activity?activityId=15
    this.activityId = this.$route.query.activityId
    this.shareUserId = appUser.userId
    console.log(appUser.userId)
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getDataShare()
  },
  mounted() {},
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      console.log(appUser.userId)
      this.shareUserId = appUser.userId
      setTimeout(() => {
        this.getData()
        this.getDataShare()
      })
    },
    //活动概览
    getData() {
      activityService
        .activityDetail({
          activityId: this.activityId
        })
        .then(res => {
          this.dataDetail = res
          if (res) this.title = this.dataDetail.activityName
        })
    },
    //获取分享海报
    getDataShare() {
      if (!this.shareUserId) return
      activityService
        .activityShare({
          activityId: this.activityId,
          shareUserId: this.shareUserId
        })
        .then(res => {
          this.dataShareDetail = res
          this.$set(this.dataShareDetail, 'canvasObj', [])
          res.shareImgUrls.forEach(item => {
            this.dataShareDetail.canvasObj.push({ picUrl: item, canvasUrl: item, isGenerate: false })
          })

          this.makeQRcode()

          // setTimeout(() => {
          //   for (let i = 0; i < res.shareImgUrls.length; i++) {
          //     this.createImage(i)
          //   }
          // }, 100)
        })
    },
    // 设置分享数据
    setShareData() {
      if (this.dataDetail && this.dataDetail.shareMainTitle) {
        return {
          title: this.dataDetail.shareMainTitle,
          desc: this.dataDetail.shareSecondTitle,
          link: location.href,
          imgUrl: this.dataDetail.shareImg
        }
      }
    },
    //生成海报
    generatePoster() {
      if (!this.checkStatus()) return
      if (this.dataDetail.activityStatus === 2) {
        this.$toast('活动已结束！')
        return
      }

      this.dialogShow = true
      //生成图片结束关闭Toast.clear()
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      })
      // saTrack('invitePosterCreateClick', {
      //   activity_id: '',
      //   poster_id: '',
      //   poster_name: '',
      //   salesman_id: ''
      // })
      //五秒钟后关闭Toast
      setTimeout(() => {
        Toast.clear()
      }, 6000)
    },
    progressClick() {
      if (!this.checkStatus()) return
      this.$router.push({ path: 'activity_progress', query: this.$route.query })
    },
    checkStatus() {
      if (!this.dataDetail || this.dataDetail.activityStatus === 0) {
        this.$toast('活动未开始！')
        return false
      }
      return true
    },
    //生成二维码
    makeQRcode() {
      let shareQrContent = this.dataShareDetail.shareUrl
      if (!shareQrContent) return
      const opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.3,
        margin: 1
      }
      QRCode.toDataURL(shareQrContent, opts).then(url => {
        this.qrImgpath = url
      })
    },
    onImageLoad(index) {
      this.createImage(index)
    },
    createImage(index) {
      try {
        const capture = document.getElementById('capture' + index)
        html2canvas(capture, {
          backgroundColor: null,
          useCORS: true,
          width: capture.offsetWidth,
          height: capture.offsetHeight,
          scrollX: 0,
          scrollY: 0,
          x: 0,
          y: 0,
          scale: 4
        })
          .then(canvas => {
            // document.body.appendChild(canvas)
            const dataURL = canvas.toDataURL('image/png')
            this.$set(this.dataShareDetail.canvasObj[index], 'canvasUrl', dataURL)
            this.$set(this.dataShareDetail.canvasObj[index], 'isGenerate', true)
          })
          .finally(() => {
            console.log('生成结束')
            Toast.clear()
          })
      } catch (err) {
        Toast.clear()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.longpress {
  position: absolute;
  text-align: center;
  left: 0;
  right: 0;
  bottom: -30px;
  font-size: 16px;
  color: #fff;
}
.my-swiper {
  position: absolute;
  width: 100vw;
  height: 135vw;
  top: 50%;
  margin-top: -75vw;
}
.swiper-container {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow: visible !important;
  .swiper-wrapper .swiper-slide {
    width: 81vw;
    border-radius: 8px;
    overflow: hidden;
    transform: none !important;
    height: 125vw;
    margin-top: 5vw;
  }
  .swiper-slide-active {
    height: 100% !important;
    margin-top: 0 !important;
  }
  .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  .swiper-pagination {
    font-size: 28px;
    color: #8a91a4;
    bottom: -80px !important;
  }
}
.qrcode {
  position: absolute;
  bottom: 16px;
  right: 16px;
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #000;
  width: 80px;
  height: 80px;
  background-color: #fff;
}
.explain {
  position: fixed;
  top: 40px;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  padding: 8px 10px 8px 16px;
  color: #fff;
}
.explain-con {
  border: 5px solid #366c6d;
  border-radius: 8px;
  position: relative;
  height: 80vh;
  margin: 0 20px;
  margin-top: 10vh;
  background: #fff;
  padding: 45px 0px 76px;
  .title {
    position: absolute;
    top: -9px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 120px;
    height: 50px;
    line-height: 42px;
    text-align: center;
    background: url('./images/rule_title_bg.png') no-repeat;
    background-size: 100% auto;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
  .container {
    padding: 0 20px;
    line-height: 22px;
    height: 100%;
    overflow-y: auto;
  }
  .myrule {
    h3 {
      margin-top: 16px;
      margin-bottom: 5px;
      font-size: 16px;
    }
    p {
      font-size: 14px;
      color: #555;
    }
  }
  .know {
    position: absolute;
    background-color: #fff;
    bottom: 0;
    width: 100%;
    padding: 16px;
  }
}
</style>
